// removed by extract-text-webpack-plugin
module.exports = {"container":"_2dgtWgHvC4ejfKWKS8P-b_","header_item":"_2dEAQHCJc4Ov0pl-Jm4ww_","download_pane":"_23jy3jKQVt-fqVeftmaZRD","url_list":"_12Ij3ifnvROA7Ktncbwzpx"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Download/index.less
// module id = 507
// module chunks = 0